import './Networking.css'
import NetworkingOpt from "../../components/seo/NetworkingOpt";

export default function NetworkFundamentals() {
    return (
        <>
            <NetworkingOpt
                title="Network Fundamentals"
                description="Study networking fundamentals including network devices, Ethernet standards, protocols, ports, ARP, TCP, UDP, and VPN concepts."
                keywords="network fundamentals, ethernet, arp, tcp, udp, ports, vpn, networking basics"
            />
            <article className='content'>
                <h1 style={{display:'flex', justifyContent:'center'}}>Network Fundamentals</h1>

                <h2>1. Introduction</h2>
                

                <p>A computer network is a digital telecommunications system that allows nodes to share resources and communicate efficiently.</p>

                <h2>2. Networking Devices</h2>
                

                <h3>Firewall</h3>
                

                <p>Monitors and controls network traffic based on configured rules.</p>
                <p>Can be placed inside or outside the network.</p>
                <p><em>Types of Firewalls:</em></p>
                <p>Network Firewall: Hardware device that filters traffic between networks.</p>  
                <p>Host-Based Firewall: Software application that filters traffic entering or exiting a host machine (e.g., a PC).</p>
                

                <h3>Router</h3>
                <p>Designed to forward traffic between networks.</p>
                <p>Operates at Layer 3 (Network Layer) of the OSI model.</p>

                <h2>3. Network Protocols</h2>
                
                <p>Define common language standards between network devices.</p>
                <p>Internet Protocol (IP): Provides logical addressing for devices on a network.</p>
                

                <h3>Bits and Bytes</h3>
                

                <p>All data is represented in binary (0s and 1s).</p>
                <p>1 Byte = 8 Bits.</p>
                <p>Speed is measured in bits per second (bps).</p>            
                <p>Data size is measured in bytes.</p>
                

                <h3>Ethernet Standards</h3>
                
                <p>Defined as IEEE 802.3 standard (1983).</p>
                <p>IEEE = <em>Institute of Electrical and Electronics Engineers</em>.</p>
                <p>Base refers to <em>baseband signaling</em>.</p>
                <p>T = <em>Twisted Pair</em>.</p>
                <h2>4. Ethernet Frame</h2>
                <p>Header + Trailer: 18 bytes total.</p>
                <p>Minimum Frame Size: 64 bytes.</p>
                <p>Payload minimum = 46 bytes (64 - 18 = 46).</p>
                <p>If payload &lt; 46 bytes → padding bytes are added.</p>
                <p>Preamble + SFD are sent but not counted in header size.</p>
                

                <h3>Ethernet LAN Switching: </h3>
                

                <h4>Preamble</h4>

                <p>Length: 7 bytes (56 bits)</p>
                <p>Pattern: Alternating 1s and 0s → 10101010 × 7</p>
                <p>Purpose: Synchronizes receiver clocks.</p>
                

                <h4>Start Frame Delimiter (SFD)</h4>

                <p>Length: 1 byte (8 bits)</p>
                <p>Pattern: 10101011</p>
                <p>Purpose: Marks the end of the preamble and start of the frame.</p>
                

                <h4>Destination &amp; Source</h4>

                <p>Indicate sending and receiving devices.</p>
                <p>Contain MAC Addresses (Media Access Control).</p>
                <p>MAC Address: 6 bytes (48 bits) — unique physical address.</p>
                

                <h4>Type/Length</h4>

                <p>2 bytes (16 bits)</p>
                <p>≤1500: Indicates payload length (in bytes).</p>
                <p>≥1536: Indicates protocol type (e.g., IPv4, IPv6).</p>
                
      
                <h4>Frame Check Sequence (FCS)</h4>

                <p>4 bytes (32 bits)</p>
                <p>Detects corrupted data using CRC (Cyclic Redundancy Check).</p>

                <h2>5. MAC Address</h2>
                

                <p>6 bytes (48 bits) physical address assigned during manufacturing.</p>
                <p>Also called Burned-In Address (BIA).</p>
                <p>Globally unique.</p>
                <p>Structure:</p>
                <p>First 3 bytes → OUI (Organizationally Unique Identifier).</p>              
                <p>Last 3 bytes → Device-specific identifier (hexadecimal).</p>
                

                <h3>Address Resolution Protocol (ARP)</h3>
                

                <p>Used to discover Layer 2 (MAC) address of a known Layer 3 (IP) address.</p>
                <p>Messages:</p>
                <p>ARP Request: “Who has this IP?”</p>
                <p>ARP Reply: “I have this IP.”</p>
                <h2>6. Transport Layer Protocols</h2>
                

                <h3>Transmission Control Protocol (TCP)</h3>
                

                <p>Connection-oriented and reliable.</p>
                <p>Uses a three-way handshake to establish connection.</p>
                <p>Ensures packet order, error checking, and retransmission.</p>
                <p>Slower due to overhead.</p>
                <p>Used for: Web browsing, file transfers, email.</p>
                

                <h3>User Datagram Protocol (UDP)</h3>
                

                <p>Connectionless and unreliable.</p>
                <p>No guarantee of delivery or order.</p>
                <p>Faster, smaller header, minimal overhead.</p>
                <p>Used for: Video streaming, online gaming, VoIP.</p>

                <h2>7. Web and Remote Access Ports</h2>
                
                <table>
                    <tr><td>Service</td><td>Protocol</td><td>Port</td></tr>
                    <tr><td>HTTP</td><td>TCP</td><td>80</td></tr>
                    <tr><td>HTTPS</td><td>TCP</td><td>443</td></tr>
                    <tr><td>SSH</td><td>TCP</td><td>22</td></tr>
                    <tr><td>Telnet</td><td>TCP</td><td>23</td></tr>
                    <tr><td>RDP</td><td>TCP</td><td>3389</td></tr>
                </table>

                <h2>8. Email Ports</h2>
                <table>
                    <tr><td>Service</td><td>Protocol</td><td>Ports</td></tr>
                    <tr><td>SMTP</td><td>TCP</td><td>25, 465, 587</td></tr>
                    <tr><td>POP3</td><td>TCP</td><td>110</td></tr>
                    <tr><td>IMAP</td><td>TCP</td><td>143</td></tr>
                </table>

                <h2>9. File Transfer Ports </h2>
                

                <table>
                    <tr><td>Service</td><td>Protocol</td><td>Ports</td></tr>
                    <tr><td>FTP</td><td>TCP</td><td>20, 21</td></tr>
                    <tr><td>TFTP</td><td>UDP</td><td>69</td></tr>
                    <tr><td>SFTP</td><td>TCP</td><td>22</td></tr>
                </table>
                <h2>10. Network management and diagnostics</h2>
                
                <table>
                    <tr><td>Service</td><td>Protocol</td><td>Ports</td></tr>
                    <tr><td>DNS</td><td>UDP , TCP</td><td>53 (queries), 53 (zone transfers)</td></tr>
                    <tr><td>DHCP</td><td>UDP </td><td>67, 68<br/></td></tr>
                    <tr><td>NTP</td><td>UDP </td><td>123</td></tr>
                    <tr><td>SNMP</td><td>UDP </td><td>161</td></tr>
                    <tr><td>Syslog</td><td>UDP </td><td>514</td></tr>
                </table>
                <h2>11. Port number ranges</h2>
                <table>
                    <tr><td>Range</td><td>Name</td><td>Usage</td></tr>
                    <tr><td>0–1023</td><td>Well-Known Ports</td><td>Common services</td></tr>
                    <tr><td>1024–49151</td><td>Registered Ports</td><td>Specific applications</td></tr>
                    <tr><td>49152–65535</td><td>Dynamic/Private Ports</td><td>Temporary/private connections</td></tr>
                </table>
                <h2>12. Unshielded Twisted Pair (UTP) Cables</h2>
                

                <p>Copper cables used in Ethernet standards are UTP cables.</p>
                <p>Unshielded means the wires do not have a metallic shield, making them more vulnerable to electrical interference.</p>
                <p>Composed of four pairs of twisted wires.</p>
                <p>Twisting helps protect against Electromagnetic Interference (EMI).</p>
                <p>RJ45 connector: 8 wires total.</p>
                
                <table>
                    <tr><td>Ethernet Standard</td><td>Wire Pairs Used</td><td>Total Wires</td></tr>
                    <tr><td>10BASE‑T / 100BASE‑T</td><td>2 pairs</td><td>4 wires</td></tr>
                    <tr><td>1000BASE‑T / 10GBASE‑T</td><td>4 pairs</td><td>8 wires</td></tr>
                </table>
                
                <p>Full Duplex: Both devices can send and receive data simultaneously using separate wire pairs, preventing collisions.</p>
                <p>Auto MDI‑X: Automatically detects cable type, eliminating the need for straight‑through or crossover cables.</p>
                

                <h3>Straight‑Through Cable</h3>
                

                <p>Used to connect different device types (e.g., PC to switch, switch to router).</p>
                <p>Transmit and receive pins are on opposite pairs.</p>
                

                <h3>Crossover Cable</h3>
                

                <p>Used to connect similar devices (e.g., PC to PC, switch to switch).</p>
                <p>Transmit pins on one end connect to receive pins on the other — wires are “crossed over.”</p>
                

                <h3>Fiber-optic Cables</h3>
                

                <p>Use light signals transmitted through a glass fiber core.</p>
                <p>Connected via Small Form‑Factor Pluggable (SFP) transceivers.</p>
                

                <h4>Fiber Layers</h4>
                

                <p>Core: Fiberglass center where light travels.</p>
                <p>Cladding: Reflects light back into the core.</p>
                <p>Buffer: Protects the cladding and core.</p>
                <p>Outer Jacket: Provides physical protection.</p>
                

                <h4>Types of Fiber</h4>
                

                <table>
                    <tr><td>Type</td><td>Core Diameter</td><td>Light Source</td><td>Range</td><td>Cost</td><td>Notes</td></tr>
                    <tr><td>Single‑Mode Fiber (SMF)</td><td>Narrow</td><td>Laser</td><td>Long</td><td>Expensive</td><td>Light enters at a single angle.</td></tr>
                    <tr><td>Multi‑Mode Fiber (MMF)</td><td>Wide</td><td>LED</td><td>Medium</td><td>Cheaper</td><td>Multiple light angles (modes) enter the core.</td></tr>
                </table>
                

                <h4>Fiber‑Optic Cable Standards</h4>
                

                <p>Defined by IEEE 802.3 and ANSI/TIA specifications.</p>
                <p>Common connectors: LC, SC, ST.</p>
                <p>Common types: 10GBASE‑SR, 10GBASE‑LR, 100GBASE‑ER (depending on range and wavelength).</p>

                <h2>13. OSI Model (Open Systems Interconnection)</h2>
                

                <p>A conceptual framework developed by ISO (International Organization for Standardization) to standardize communication functions across systems.</p>
                <p>It consists of seven layers, each with distinct roles.</p>
                

                <h3>Layer 7 – Application Layer</h3>
                

                <p>Closest to the end user; interacts with software applications (e.g., web browsers).</p>
                <p>Examples: HTTP, HTTPS, FTP, SMTP.</p>
                <p>Functions:</p>
                <p>Identifies communication partners.</p>
                <p>Synchronizes communication.</p>
                <p>Enables process‑to‑process interaction.</p>
                

                <h3>Layer 6 – Presentation Layer</h3>
                

                <p>Translates data between application format and network format.</p>
                <p>Handles encryption, compression, and data translation.</p>
                <p>Examples: SSL/TLS encryption.</p>
                <p>Encapsulation/De‑encapsulation: Interaction between adjacent layers.</p>
                

                <h3>Layer 5 – Session Layer</h3>
                

                <p>Manages sessions between communicating hosts.</p>
                <p>Establishes, maintains, and terminates connections (e.g., between a browser and a web server).</p>
                <p>Controls dialogue synchronization and recovery.</p>
                <p>Network engineers typically focus on Layers 1–4.</p>
                

                <h4>Encapsulation Process</h4>
                

                <table>
                    <tr><td>Step</td><td>Description</td><td>Resulting PDU</td></tr>
                    <tr><td>Upper Layer</td><td>Raw Data</td><td>Data</td></tr>
                    <tr><td>+ L4 Header</td><td>Transport Layer</td><td>Segment</td></tr>
                    <tr><td>+ L3 Header</td><td>Network Layer</td><td>Packet</td></tr>
                    <tr><td>+ L2 Header + Trailer</td><td>Data Link Layer</td><td>Frame</td></tr>
                </table>

                <h4>PDU (Protocol Data Unit):</h4>
                
                <p>Generic term for data at each layer.</p>
                

                <h3>Layer 4 – Transport Layer</h3>
                

                <p>Segments and reassembles data for host‑to‑host communication.</p>
                <p>Ensures reliable delivery (TCP) or fast transmission (UDP).</p>
                <p>Breaks large data into smaller segments for efficient transfer.</p>
                

                <h3>Layer 3 – Network Layer</h3>
                

                <p>Provides connectivity between different networks.</p>
                <p>Handles logical addressing (IP) and path selection.</p>
                <p>Devices: Routers operate at this layer.</p>
                <p>Responsible for packet forwarding and routing.</p>
                

                <h3>Layer 2 – Data Link Layer</h3>
                

                <p>Provides node‑to‑node connectivity(e.g., PC ↔ switch ↔ router).</p>
                <p>Defines frame formatting for transmission over physical media.</p>
                <p>Detects and may correct physical layer errors.</p>
                <p>Devices: Switches operate at this layer.</p>
                <p>Uses MAC addressing.</p>
                

                <h3>Layer 1 – Physical Layer</h3>
                

                <p>Defines physical characteristics of transmission media.</p>
                <p>Examples: Voltage levels, connectors, cable types, signal modulation.</p>
                <p>Converts digital bits into electrical or radio signals.</p>
                <p>Devices: Hubs, repeaters, cables.</p>

                <h2>14. TCP/IP Suite</h2>
                <p>Conceptual model and set of protocols used for Internet communication.</p>
                <p>Named after its two core protocols: TCP and IP.</p>
                <p>Developed by the U.S. Department of Defense (DARPA).</p>
                <p>Forms the foundation of modern networking.</p>
                <h2>15. Network Topologies (LAN/WAN Architectures)</h2>
                
                <table>
                    <tr><td>Topology</td><td>Description</td></tr>
                    <tr><td>Star</td><td>All devices connect to a central device (e.g., switch or hub). Common in modern LANs.</td></tr>
                    <tr><td>Full Mesh</td><td>Every device connects directly to every other device. Provides high redundancy.</td></tr>
                    <tr><td>Partial Mesh</td><td>Some devices are interconnected, but not all. Balances cost and redundancy.</td></tr>
                </table>
                

                <h3>Two‑Tier Campus LAN Design </h3>
                

                <p>Consists of two hierarchical layers:</p>
                

                <h4>Access Layer</h4>
                <p>Connects end hosts (PCs, printers, phones, APs).</p>
                <p>Switches have many ports for host connections.</p>
                <p>Performs QoS marking and security services(e.g., Port Security, DAI).</p>
                <p>PoE‑enabled ports support wireless APs and IP phones.</p>
                

                <h4>Distribution Layer</h4>
                <p>Aggregates connections from Access Layer switches.</p>
                <p>Acts as the border between Layer 2 and Layer 3.</p>
                <p>Connects to core services such as Internet and WAN.</p>
                

                <h3>Three‑Tier Campus LAN Design</h3>
                

                <p>Used in large enterprise networks with multiple distribution layers.</p>
                

                <h4>Core Layer</h4>
                <p>Connects distribution layers together.</p>
                <p>Focuses on speed and reliability (“fast transport”).</p>
                <p>Avoids CPU‑intensive tasks like security filtering or QoS classification.</p>
                <p>Operates entirely at Layer 3 (no spanning tree).</p>
                <p>Ensures redundant connectivity across the LAN.</p>
                

                <h3>Spine‑Leaf Architecture</h3>
                

                <p>Modern data center design replacing traditional three‑tier models.</p>
                

                <h4>Concept</h4>
                <p>Traditional designs handle north‑south traffic (client ↔ server).</p>
                <p>Virtualized and distributed applications increase east‑west traffic(server ↔ server).</p>
                <p>Spine‑Leaf (Clos) architecture improves bandwidth and reduces latency.</p>
                

                <h4>Rules</h4>

                <p>Every Leaf switch connects to every Spine switch.</p>
                <p>Leaf switches do not connect to other leafs; spines do not connect to other spines.</p>
                <p>End hosts connect only to Leaf switches.</p>
                <p>Traffic paths are load‑balanced across spine switches.</p>
                

                <h3>SOHO Networks</h3>
                

                <p>Small Office/Home Office (SOHO)networks serve small businesses or home setups.</p>
                <p>All networking functions (routing, switching, wireless, firewall) are typically handled by a single device(e.g., home router).</p>
                

                <h3>WAN Architectures</h3>
                

                <h4>Overview</h4>
                <p>WAN (Wide Area Network) spans large geographic areas.</p>
                <p>Connects enterprise sites, data centers, and remote offices.</p>
                

                <h4>Connection Types</h4>
                <table>
                    <tr><td>Type</td><td>Description</td></tr>
                    <tr><td>Ethernet (Fiber)</td><td>High‑speed WAN link using fiber optics.</td></tr>
                    <tr><td>Internet VPN</td><td>WAN over shared public infrastructure.</td></tr>
                    <tr><td>Leased Line</td><td>Dedicated physical link between sites; uses PPP or HDLC encapsulation.</td></tr>
                </table>
                <p>Leased lines offer consistent speed and reliability.</p>
                <p>Standards vary by country and provider.</p>

                <h2>16. Multi‑Protocol Label Switching (MPLS)</h2>
                

                <p>Service providers use shared MPLS infrastructure for enterprise WANs.</p>
                <p>Enables VPN creation using labels for packet forwarding.</p>
                <p>Operates at Layer 2.5 (between Data Link and Network layers).</p>
                

                <h3>Key Terms</h3>
                <p>PE routers add labels to frames received from CE routers.</p>
                <p>Labels determine forwarding paths within the provider network.</p>
                <p>CE routers do not use MPLS — only PE/P routers do.</p>
                <p>CE and PE typically peer at Layer 2.</p>
                

                <h3>Internet Connections</h3>
                

                <p>Private WAN technologies (e.g., leased lines, MPLS VPNs) can connect to a provider’s Internet backbone.</p>
                <p>Common Access Types</p>
                

                <table>
                    <tr><td>Type</td><td>Description</td></tr>
                    <tr><td>Fiber Optic</td><td>High‑speed, low‑latency connection.</td></tr>
                    <tr><td>CATV (Cable Internet)</td><td>Uses cable TV lines for Internet access.</td></tr>
                    <tr><td>DSL (Digital Subscriber Line)</td><td>Uses phone lines; requires a DSL modem for data conversion.</td></tr>
                </table>
                

                <h3>Redundant Internet Connections</h3>
                

                <table>
                    <tr><td>Configuration</td><td>Description</td></tr>
                    <tr><td>Single‑Homed</td><td>One connection to one ISP.</td></tr>
                    <tr><td>Dual‑Homed</td><td>Two connections to one ISP for redundancy.</td></tr>
                </table>
                <h2>17. Virtual Private Network (VPN)</h2>
                

                <p>A VPN creates a secure, encrypted tunnel for private communication over public networks (e.g., Internet).</p>
                <p>Protects data in transit, the most vulnerable state of data.</p>
                <p>Security Goals</p>
                <table>
                    <tr><td>Goal</td><td>Description</td></tr>
                    <tr><td>Confidentiality</td><td>Encryption prevents unauthorized access.</td></tr>
                    <tr><td>Integrity</td><td>Ensures data is not altered.</td></tr>
                    <tr><td>Authentication</td><td>Verifies peer identity.</td></tr>
                    <tr><td>Anti‑Replay</td><td>Prevents reuse of captured packets.</td></tr>
                </table>
                

                <h3>Types of VPN</h3>
                

                <h4><em>Site‑to‑Site VPN</em></h4>

                <p>Connects entire networks (e.g., branch ↔ HQ).</p>
                <p>Common in enterprise WANs and cloud‑to‑on‑premises setups.</p>
                <p>Characteristics:</p>
                <p>Router/firewall ↔ router/firewall</p>
                <p>Always‑on connection</p>
                <p>Uses IPsec protocol suite</p>
                

                <h4><em>Remote Access VPN</em></h4>

                <p>Used by individual users connecting remotely to corporate networks.</p>
                <p>Types:</p>
                <p>IPsec Remote Access VPN</p>
                <p>SSL VPN(browser‑based or client‑based)</p>
                <p>VPN Technologies &amp; Protocols</p>
                

                <h4><em>IPsec (Internet Protocol Security)</em></h4>

                <p>Dominant VPN protocol suite for site‑to‑site and remote access VPNs.</p>
                <p>Provides encryption, authentication, integrity, and anti‑replay.</p>
                
                <h5>Components:</h5>
                <table>
                    <tr><td>Phase</td><td>Description</td></tr>
                    <tr><td>IKE Phase 1</td><td>Builds secure channel (ISAKMP SA).</td></tr>
                    <tr><td>IKE Phase 2</td><td>Negotiates IPsec tunnel (IPsec SA).</td></tr>
                    <tr><td>ESP</td><td>Encrypts and authenticates data.</td></tr>
                    <tr><td>AH</td><td>Authenticates only (rarely used).</td></tr>
                </table>
                

                <h4><em>GRE (Generic Routing Encapsulation)</em></h4>

                <p>Tunneling protocol that carries non‑IP traffic or supports routing protocols across tunnels.</p>
                <p>Often combined with IPsec for encryption (GRE over IPsec).</p>
                <h5><em>SSL/TLS VPN</em></h5>
                <p>Primarily used for remote access.</p>
                <p>Operates over HTTPS (TCP 443) — firewall‑friendly.</p>
                <p>Provides secure, browser‑based connectivity.</p>
                
            </article>

            </>

            )
};
